<template>
  <select
    v-bind="$attrs"
    class="form-control"
    :value="$attrs.modelValue"
    data-test="country-select"
    @input="$emit('update:modelValue', $event.target.value)"
  >
    <option value="" disabled>{{ $t('Select country') }}</option>
    <option v-for="(countryName, cca2) in countriesGlobal" :key="cca2" :value="cca2">
      {{ $t(countryName) }}
    </option>
  </select>
</template>

<script>
export default {
  computed: {
    countriesGlobal() {
      return countriesGlobalVar
    },
  },
}
</script>
